import { render, staticRenderFns } from "./FormatTime.vue?vue&type=template&id=54447263"
import script from "./FormatTime.vue?vue&type=script&lang=ts"
export * from "./FormatTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports